import React, { useState, useEffect, useRef } from "react";
import './Addressdetails.css';
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select';
// import axios from "axios";
import { addressdetailsSubmit, getAddressDetailsBasedonEmployeeUniqueeId, getEmployeeDetailsBasedonEmployeeUniqueeId, getNationalities, getStatesByCountry } from "../../../../../../services/employeeCreationService";
import { getBlocks, getDistrict } from "../../../../../../services/monthlyAttendanceService";
import { getAuditLog } from "../../../../../../utils/calculateDaysInMonthUtils";
import ConfirmModal from "../../../../../../components/common/ConfirmModal/ConfirmModal";
import { capitalizeFirstLetter } from "../../../../../../utils/validations";
import { selectStyleDisable, selectStyles } from "../../../../../../assets/Styles/selectStyle";

const AddressDetails = ({ onNext, onPrevious }) => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  //const employeeUniqueId = searchParams.get('employeeUniqueId') || location.state?.applicationId;

  const fromUrl = searchParams.get('employeeUniqueId');   // <-- from query string
  const fromState = location.state?.applicationId;        // <-- from navigation state

  // Use the URL value **only if it exists** – otherwise fall back to state
  const employeeUniqueId = fromUrl ?? fromState;
  const [completed, setCompleted] = useState(false);   // <-- NEW
  const isLocked = Boolean(fromUrl && completed);
  const effectRan = useRef(false);
  const [isDirty, setIsDirty] = useState(false);
  const [presentBlockOptions, setPresentBlockOptions] = useState([]);
  const [permanentBlockOptions, setPermanentBlockOptions] = useState([]);
  const [addressData, setAddressData] = useState({
    id: "",
    presentCountry: '',
    presentState: '',
    presentDistrict: '',
    presentBlockId: '',
    presentMandal: '',
    presentAddressLine1: '',
    presentAddressLine2: '',
    presentPostCode: '',
    permanentCountry: '',
    permanentState: '',
    permanentDistrict: '',
    permanentBlockId: '',
    permanentMandal: '',
    permanentAddressLine1: '',
    permanentAddressLine2: '',
    permanentPostCode: '',
  });
  const [personalInfo, setPersonalInfo] = useState({
    givenName: "",
    surname: "",
    jobPosition: "",
  });
  const [stateOptions, setStateOptions] = useState([]);
  const [permanentStateOptions, setPermanentStateOptions] = useState([]);
  const [countries, setCountries] = useState([]);
  const [presentDistrictOptions, setPresentDistrictOptions] = useState([]);
  const [permanentDistrictOptions, setPermanentDistrictOptions] = useState([]);
  const [errors, setErrors] = useState({});
  const [isSameAddress, setIsSameAddress] = useState(false);
  const [isStateFocused, setIsStateFocused] = useState(false);
  const [isDistrictFocused, setIsDistrictFocused] = useState(false);
  const [isBlockFocused, setIsBlockFocused] = useState(false);
  const [isPermStateFocused, setIsPermStateFocused] = useState(false);
  const [isPermDistrictFocused, setIsPermDistrictFocused] = useState(false);
  const [isPermBlockFocused, setIsPermBlockFocused] = useState(false);


  const [focusInput, setFocusInput] = useState({
    presentAddressLine1: false,
    presentAddressLine2: false,
    presentPostCode: false,
    presentCountry: false,
    presentPostCode: false,
  });
  const [focusPermanentInput, setFocusPermanentInput] = useState({
    permanentAddressLine1: false,
    permanentAddressLine2: false,
    permanentPostCode: false,
    permanentCountry: false,
    permanentPostCode: false,
  });
  const [isLoadingOptions, setIsLoadingOptions] = useState(false);
  //const [completed, setCompleted] = useState(false);   // <-- NEW
  const isFieldDisabled = completed;               // simple case
  const navigate = useNavigate();
  const requiredFields = [
    'presentCountry', 'presentState', 'presentDistrict',
    'presentAddressLine1', 'presentPostCode',
  ];
  const permanentRequiredFields = [
    'permanentCountry', 'permanentState', 'permanentDistrict',
    'permanentAddressLine1', 'permanentPostCode'
  ];
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const isNextButtonEnabled = () => {
    const presentValid = requiredFields.every(field => addressData[field] !== null && addressData[field] !== '');
    const permanentValid = isSameAddress || permanentRequiredFields.every(field => addressData[field] !== null && addressData[field] !== '');
    console.log('Validation Check:', {
      presentValid,
      permanentValid,
      addressData,
      isSameAddress,
      isNextEnabled: presentValid && permanentValid,
    });
    return presentValid && permanentValid;
  };

  const [isNextEnabled, setIsNextEnabled] = useState(false);

  useEffect(() => {
    setIsNextEnabled(isNextButtonEnabled());
  }, [addressData, isSameAddress]);

  // Fetch address data for employeeUniqueId
  // useEffect(() => {
  //   const fetchAddressData = async () => {
  //     if (employeeUniqueId) {
  //       try {
  //         setIsLoadingOptions(true);
  //         // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/address/${employeeUniqueId}`);
  //         //const data = response.data;
  //         const data = await getAddressDetailsBasedonEmployeeUniqueeId(employeeUniqueId);
  //         setAddressData({
  //           id: data.id ? String(data.id) : '',
  //           presentCountry: data.presentCountry?.id ? String(data.presentCountry.id) : '',
  //           presentState: data.presentState?.id ? String(data.presentState.id) : '',
  //           presentDistrict: data.presentDistrict?.districtId ? String(data.presentDistrict.districtId) : '',
  //           presentBlock: data.presentBlock || '',
  //           presentAddressLine1: data.presentAddressLine1 || '',
  //           presentAddressLine2: data.presentAddressLine2 || '',
  //           presentPostCode: data.presentPostCode || '',
  //           permanentCountry: data.sameAsPresent ? data.presentCountry?.id ? String(data.presentCountry.id) : '' : data.permanentCountry?.id ? String(data.permanentCountry.id) : '',
  //           permanentState: data.sameAsPresent ? data.presentState?.id ? String(data.presentState.id) : '' : data.permanentState?.id ? String(data.permanentState.id) : '',
  //           permanentDistrict: data.sameAsPresent ? data.presentDistrict?.districtId ? String(data.presentDistrict.districtId) : '' : data.permanentDistrict?.districtId ? String(data.permanentDistrict.districtId) : '',
  //           permanentBlock: data.sameAsPresent ? data.presentBlock || '' : data.permanentBlock || '',
  //           permanentAddressLine1: data.sameAsPresent ? data.presentAddressLine1 || '' : data.permanentAddressLine1 || '',
  //           permanentAddressLine2: data.sameAsPresent ? data.presentAddressLine2 || '' : data.permanentAddressLine2 || '',
  //           permanentPostCode: data.sameAsPresent ? data.presentPostCode || '' : data.permanentPostCode || '',
  //         });
  //         setIsSameAddress(data.sameAsPresent || false);

  //         // Fetch states and districts for present address
  //         if (data.presentCountry?.id) {
  //           await fetchStatesByCountry(data.presentCountry.id, 'present');
  //           if (data.presentState?.id) {
  //             await fetchDistrictsByState(data.presentState.id, 'present');
  //           }
  //         }
  //         // Fetch states and districts for permanent address if not same
  //         if (!data.sameAsPresent && data.permanentCountry?.id) {
  //           await fetchStatesByCountry(data.permanentCountry.id, 'permanent');
  //           if (data.permanentState?.id) {
  //             await fetchDistrictsByState(data.permanentState.id, 'permanent');
  //           }
  //         } else if (data.sameAsPresent) {
  //           setPermanentStateOptions(stateOptions);
  //           setPermanentDistrictOptions(presentDistrictOptions);
  //         }
  //       } catch (error) {
  //         console.error('Error fetching address data:', error);
  //         if (error.response?.status !== 404) {
  //           setErrors((prev) => ({ ...prev, general: 'Failed to load address data' }));
  //         }
  //         // Check localStorage for saved response
  //         const savedResponse = localStorage.getItem('savedAddressResponse');
  //         if (savedResponse) {
  //           const data = JSON.parse(savedResponse);
  //           setAddressData(prev => ({
  //             ...prev,
  //             id: data.id ? String(data.id) : prev.id,
  //             presentCountry: data.presentCountry?.id ? String(data.presentCountry.id) : prev.presentCountry,
  //             presentState: data.presentState?.id ? String(data.presentState.id) : prev.presentState,
  //             presentDistrict: data.presentDistrict?.districtId ? String(data.presentDistrict.districtId) : prev.presentDistrict,
  //             presentBlock: data.presentBlock || prev.presentBlock,
  //             presentAddressLine1: data.presentAddressLine1 || prev.presentAddressLine1,
  //             presentAddressLine2: data.presentAddressLine2 || prev.presentAddressLine2,
  //             presentPostCode: data.presentPostCode || prev.presentPostCode,
  //             permanentCountry: data.sameAsPresent ? data.presentCountry?.id ? String(data.presentCountry.id) : prev.permanentCountry : data.permanentCountry?.id ? String(data.permanentCountry.id) : prev.permanentCountry,
  //             permanentState: data.sameAsPresent ? data.presentState?.id ? String(data.presentState.id) : prev.permanentState : data.permanentState?.id ? String(data.permanentState.id) : prev.permanentState,
  //             permanentDistrict: data.sameAsPresent ? data.presentDistrict?.districtId ? String(data.presentDistrict.districtId) : prev.permanentDistrict : data.permanentDistrict?.districtId ? String(data.permanentDistrict.districtId) : prev.permanentDistrict,
  //             permanentBlock: data.sameAsPresent ? data.presentBlock || prev.permanentBlock : data.permanentBlock || prev.permanentBlock,
  //             permanentAddressLine1: data.sameAsPresent ? data.presentAddressLine1 || prev.permanentAddressLine1 : data.permanentAddressLine1 || prev.permanentAddressLine1,
  //             permanentAddressLine2: data.sameAsPresent ? data.presentAddressLine2 || prev.permanentAddressLine2 : data.permanentAddressLine2 || prev.permanentAddressLine2,
  //             permanentPostCode: data.sameAsPresent ? data.presentPostCode || prev.permanentPostCode : data.permanentPostCode || prev.permanentPostCode,
  //           }));
  //           setIsSameAddress(data.sameAsPresent || false);
  //         }
  //       } finally {
  //         setIsLoadingOptions(false);
  //       }
  //     }
  //   };


  //   if (!effectRan.current) {
  //     fetchAddressData();
  //   }
  //   return () => {
  //     effectRan.current = true;
  //   }

  //   setIsDirty(false);
  // }, [employeeUniqueId]);


  // Fetch countries
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        //const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/nationality`);
        const data = await getNationalities();
        //const options = res.
        setCountries(data.map((item) => ({
          value: item.id,
          label: item.nationalityName,
        })));
      } catch (err) {
        console.error("Error fetching countries:", err);
        setErrors((prev) => ({ ...prev, general: 'Failed to load countries' }));
      }
    };
    if (effectRan.current === false) {
      fetchCountries();
    }
    return () => {
      effectRan.current = true;
    }

  }, []);

  // Fetch states by country
  const fetchStatesByCountry = async (countryId, type) => {
    try {
      // const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/states/nationality/${countryId}`);
      const data = await getStatesByCountry(countryId);

      if (type === 'present') {
        setStateOptions(data.map((item) => ({
          value: item.id,
          label: capitalizeFirstLetter(item.stateName),
        })));
      } else {
        setPermanentStateOptions(data.map((item) => ({
          value: item.id,
          label: capitalizeFirstLetter(item.stateName),
        })));
      }
    } catch (err) {
      console.error(`Error fetching ${type} states:`, err);
      setErrors((prev) => ({ ...prev, general: `Failed to load ${type} states` }));
    }
  };

  // Fetch districts by state
  const fetchDistrictsByState = async (stateId, type) => {
    try {
      // const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/districts/state/${stateId}`);
      const data = await getDistrict(stateId);
      // const options = res.;
      const filteredData = data.filter(item => ![39, 40, 41].includes(item.districtId));

      if (type === 'present') {
        setPresentDistrictOptions(filteredData.map((item) => ({
          value: item.districtId,
          label: item.districtName,
        })));
      } else {
        setPermanentDistrictOptions(filteredData.map((item) => ({
          value: item.districtId,
          label: item.districtName,
        })));
      }
    } catch (err) {
      console.error(`Error fetching ${type} districts:`, err);
      setErrors((prev) => ({ ...prev, general: `Failed to load ${type} districts` }));
    }
  };

  // ---- NEW: fetch blocks for a district -----------------
  const fetchBlocksByDistrict = async (districtId, type) => {
    if (!districtId) return;

    try {
      const data = await getBlocks(districtId);   // <-- returns blocks for that district

      const blockOptions = data.map(item => ({
        value: item.id,
        label: capitalizeFirstLetter(item.blockName),
      }));

      if (type === 'present') {
        setPresentBlockOptions(blockOptions);
      } else {
        setPermanentBlockOptions(blockOptions);
      }
    } catch (err) {
      console.error(`Error fetching ${type} blocks:`, err);
      setErrors(prev => ({ ...prev, general: `Failed to load ${type} blocks` }));
    }
  };
  // Handle country change
  const handleCountryChange = (selectedOption, field) => {
    const countryId = selectedOption ? String(selectedOption.value) : '';
    setAddressData((prev) => ({
      ...prev,
      [field]: countryId,
      [field === 'presentCountry' ? 'presentState' : 'permanentState']: '',
      [field === 'presentCountry' ? 'presentDistrict' : 'permanentDistrict']: '',
      [field === 'presentCountry' ? 'presentBlock' : 'permanentBlock']: '',
    }));
    if (countryId) {
      fetchStatesByCountry(countryId, field === 'presentCountry' ? 'present' : 'permanent');
    } else {
      if (field === 'presentCountry') {
        setStateOptions([]);
        setPresentDistrictOptions([]);
      } else {
        setPermanentStateOptions([]);
        setPermanentDistrictOptions([]);
      }
    }
    if (isSameAddress && field === 'presentCountry') {
      setAddressData((prev) => ({
        ...prev,
        permanentCountry: countryId,
        permanentState: '',
        permanentDistrict: '',
        permanentBlock: '',
      }));
      setPermanentStateOptions([]);
      setPermanentDistrictOptions([]);
      if (countryId) {
        fetchStatesByCountry(countryId, 'permanent');
      }
    }
  };

  // Handle state change

  const handleStateChange = (selectedOption, field) => {
    const stateId = selectedOption ? String(selectedOption.value) : '';


    setAddressData(prev => ({
      ...prev,
      [field]: stateId,
      [field === 'presentState' ? 'presentDistrict' : 'permanentDistrict']: '',
      [field === 'presentState' ? 'presentBlock' : 'permanentBlock']: '',
    }));

    if (stateId) {
      fetchDistrictsByState(stateId, field === 'presentState' ? 'present' : 'permanent');
    } else {
      if (field === 'presentState') setPresentDistrictOptions([]);
      else setPermanentDistrictOptions([]);
    }

    // ---- SAME-AS-PRESENT SYNC (unchanged) ----
    if (isSameAddress && field === 'presentState') {
      setAddressData(prev => ({
        ...prev,
        permanentState: stateId,
        permanentDistrict: '',
        permanentBlock: '',
      }));
      setPermanentDistrictOptions([]);
      if (!isSameAddress && stateId) fetchDistrictsByState(stateId, 'permanent');
    }
  };

  // Handle district change
  // const handleDistrictChange = (selectedOption, field) => {
  //   const districtId = selectedOption ? String(selectedOption.value) : '';
  //   setAddressData((prev) => ({
  //     ...prev,
  //     [field]: districtId,
  //     [field === 'presentDistrict' ? 'presentBlock' : 'permanentBlock']: '',
  //   }));
  //   if (isSameAddress && field === 'presentDistrict') {
  //     setAddressData((prev) => ({
  //       ...prev,
  //       permanentDistrict: districtId,
  //       permanentBlock: '',
  //     }));
  //   }
  // };

 const handleDistrictChange = (selectedOption, field) => {
  const districtId = selectedOption ? String(selectedOption.value) : '';
  const type = field === 'presentDistrict' ? 'present' : 'permanent';

  setAddressData(prev => ({
    ...prev,
    [field]: districtId,
    [field === 'presentDistrict' ? 'presentBlockId' : 'permanentBlockId']: '',
    [field === 'presentDistrict' ? 'presentMandal' : 'permanentMandal']: '',
  }));

  if (districtId) {
    fetchBlocksByDistrict(districtId, type);
  } else {
    if (field === 'presentDistrict') {
      setPresentBlockOptions([]);
    } else {
      setPermanentBlockOptions([]);
    }
  }

  // === SAME AS PRESENT SYNC ===
  if (isSameAddress && field === 'presentDistrict') {
    setAddressData(prev => ({
      ...prev,
      permanentDistrict: districtId,
      permanentBlockId: '',
      permanentMandal: '',
    }));
    setPermanentBlockOptions([]); // Clear first
    if (districtId) {
      fetchBlocksByDistrict(districtId, 'permanent');
    }
  }
};
  // NEW HANDLER FOR BLOCK SELECT (State ID 3)
  // NEW HANDLER FOR BLOCK SELECT (State ID 3) - Used for both present & permanent
const handleBlockSelectChange = (selectedOption, type) => {
  const blockId = selectedOption ? String(selectedOption.value) : '';
  const blockIdKey = type + 'BlockId';
  const mandalKey = type + 'Mandal';

  setAddressData(prev => {
    const newState = {
      ...prev,
      [blockIdKey]: blockId,
      [mandalKey]: '',
    };

    if (isSameAddress && type === 'present') {
      newState.permanentBlockId = blockId;
      newState.permanentMandal = '';
    }
    return newState;
  });

  setIsDirty(true);
};
  // Handle same address checkbox
const handleSameAddressChange = (e) => {
  const checked = e.target.checked;
  setIsSameAddress(checked);

  if (checked) {
    setAddressData(prev => ({
      ...prev,
      permanentCountry: prev.presentCountry,
      permanentState: prev.presentState,
      permanentDistrict: prev.presentDistrict,
      permanentBlockId: prev.presentBlockId,
      permanentMandal: prev.presentMandal,
      permanentAddressLine1: prev.presentAddressLine1,
      permanentAddressLine2: prev.presentAddressLine2,
      permanentPostCode: prev.presentPostCode,
    }));

    // Copy ALL dropdown options
    setPermanentStateOptions(stateOptions);
    setPermanentDistrictOptions(presentDistrictOptions);
    setPermanentBlockOptions(presentBlockOptions); // ← This is key
  } else {
    setAddressData(prev => ({
      ...prev,
      permanentCountry: '',
      permanentState: '',
      permanentDistrict: '',
      permanentBlockId: '',
      permanentMandal: '',
      permanentAddressLine1: '',
      permanentAddressLine2: '',
      permanentPostCode: '',
    }));
    setPermanentStateOptions([]);
    setPermanentDistrictOptions([]);
    setPermanentBlockOptions([]);
  }
  setIsDirty(true);
};
// Corrected handleChange function

const handleChange = (e) => {
    const { name, value } = e.target;
    let updates = { [name]: value }; // Default update (e.g., AddressLine1)
    
    // Check if the input is the Mandal field (Text Input, when State ID is NOT 3)
    if (name === 'presentBlock') {
        // If the current state is NOT 3, treat this input as Mandal text
        if (Number(addressData.presentState) !== 3) {
            updates.presentMandal = value;
            // Also ensure BlockId is cleared, as this input is mutually exclusive with Block Select
            updates.presentBlockId = ''; 
        }
    }
    
    // Check if the input is the Permanent Mandal field
    if (name === 'permanentBlock') {
        // If the permanent state is NOT 3, treat this input as Mandal text
        if (Number(addressData.permanentState) !== 3) {
            updates.permanentMandal = value;
            // Also ensure BlockId is cleared
            updates.permanentBlockId = '';
        }
    }

    setAddressData((prev) => ({
        ...prev,
        ...updates,
        ...(isSameAddress && name.startsWith('present') && {
            // Sync permanent field value
            [name.replace('present', 'permanent')]: value,
            // Sync permanent Mandal field for submission
            ...(name === 'presentBlock' && Number(addressData.presentState) !== 3 && {
                permanentMandal: value,
                permanentBlockId: '' // Clear ID if present Mandal is typed
            }),
            // Sync permanent BlockId field for submission (This case should not happen via direct text input but for completeness)
            ...(name === 'presentBlock' && Number(addressData.presentState) === 3 && {
                permanentBlockId: value,
                permanentMandal: '' // Clear Mandal if Block ID is set
            }),
        }),
    }));
    setIsDirty(true);
};

  // Validate form
  const validate = () => {
    const newErrors = {};
    if (!addressData.presentCountry) newErrors.presentCountry = 'Present Country is required';
    if (!addressData.presentState) newErrors.presentState = 'Present State is required';
    if (!addressData.presentDistrict) newErrors.presentDistrict = 'Present District is required';
    //if (!addressData.presentBlock) newErrors.presentBlock = 'Present Block is required';
    if (!addressData.presentAddressLine1) newErrors.presentAddressLine1 = 'Present Address Line 1 is required';
    //if (!addressData.presentPostCode) newErrors.presentPostCode = 'Present Post Code is required';
    //else if (!/^\d{6}$/.test(addressData.presentPostCode)) newErrors.presentPostCode = 'Present Post Code must be a 6-digit number';

    if (!isSameAddress) {
      if (!addressData.permanentCountry) newErrors.permanentCountry = 'Permanent Country is required';
      if (!addressData.permanentState) newErrors.permanentState = 'Permanent State is required';
      if (!addressData.permanentDistrict) newErrors.permanentDistrict = 'Permanent District is required';
      // if (!addressData.permanentBlock) newErrors.permanentBlock = 'Permanent Block is required';
      if (!addressData.permanentAddressLine1) newErrors.permanentAddressLine1 = 'Permanent Address Line 1 is required';
      //if (!addressData.permanentPostCode) newErrors.permanentPostCode = 'Permanent Post Code is required';
      //else if (!/^\d{6}$/.test(addressData.permanentPostCode)) newErrors.permanentPostCode = 'Permanent Post Code must be a 6-digit number';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      return;
    }

    if (!employeeUniqueId) {
      const errorMessage = 'Draft ID is missing. Please ensure you are accessing the form correctly.';
      alert(errorMessage);
      setErrors((prev) => ({ ...prev, general: errorMessage }));
      return;
    }
    const getBlockValue = (idString) => {
      // If the string is empty or null, return null (database requires null/valid ID)
      if (!idString) return null;
      // Otherwise, convert the string ID to a number
      return Number(idString);
    }
    const fullName = localStorage.getItem("full_name");
    const role = localStorage.getItem("role");
    const employeeId = localStorage.getItem("employeeId");
    const presentBlockFields = Number(addressData.presentState) === 3 ?
      { presentBlockId: getBlockValue(addressData.presentBlockId) } :
      { presentMandal: addressData.presentMandal.trim() || null }; // Send null if empty text
    // ✅ payload should not wrap in "address"
    const payload = {
      address: {
        //  id: addressData.id ? Number(addressData.id) : {},
        ...(addressData.id ? { id: addressData.id } : {}),
        presentCountryId: Number(addressData.presentCountry),
        presentStateId: Number(addressData.presentState),
        presentDistrictId: Number(addressData.presentDistrict),
        // presentBlock: addressData.presentBlock.trim(),
        presentAddressLine1: addressData.presentAddressLine1.trim(),
        presentAddressLine2: addressData.presentAddressLine2?.trim() || '',
        presentPostCode: addressData.presentPostCode.trim(),
        sameAsPresent: isSameAddress,
        ...presentBlockFields, // Inject BlockId OR Mandal field
      },
      auditLog: getAuditLog(),
    };
    if (!isSameAddress) {
      const permanentBlockFields = Number(addressData.permanentState) === 3 ?
        { permanentBlockId: getBlockValue(addressData.permanentBlockId) } :
        { permanentMandal: addressData.permanentMandal.trim() || null }; // Send null if empty text
      payload.address = {
        ...payload.address, // keep present fields
        permanentCountryId: Number(addressData.permanentCountry),
        permanentStateId: Number(addressData.permanentState),
        permanentDistrictId: Number(addressData.permanentDistrict),
        // permanentBlock: addressData.permanentBlock.trim(),
        permanentAddressLine1: addressData.permanentAddressLine1.trim(),
        permanentAddressLine2: addressData.permanentAddressLine2?.trim() || "",
        permanentPostCode: addressData.permanentPostCode.trim(),
        ...permanentBlockFields,
      };
    }


    // if (employeeId && role) {
    //   // payload.auditLog = {
    //   //   name: fullName,
    //   //   role: role,
    //   //   employeeId: employeeId,
    //   // };
    //   payload.auditLog = getAuditLog();
    // }

    console.log("Submitting payload:", payload);

    try {
      // const url = `${process.env.REACT_APP_API_BASE_URL}/api/address/${employeeUniqueId}`;
      // const response = await axios.patch(url, payload, {
      //   headers: { "Content-Type": "application/json" },
      // });
      const response = await addressdetailsSubmit(employeeUniqueId, payload);

      //const reponse= await addressdetailsSubmit(employeeUniqueId,payload);
      console.log("Address submission response:", response.data);

      // ✅ Save ID returned by backend
      setAddressData((prev) => ({
        ...prev,
        id: response.data.id ? String(response.data.id) : prev.id,
      }));

      localStorage.setItem("savedAddressResponse", JSON.stringify(response.data));
      localStorage.setItem(
        "addressData",
        JSON.stringify({
          ...addressData,
          id: response.data.id ? String(response.data.id) : addressData.id,
          sameAsPresent: isSameAddress,
        })
      );

      onNext();
    } catch (error) {
      console.error("Submission error:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });

      let errorMessage = "Failed to submit address data. Please try again.";
      if (error.response) {
        if (error.response.status === 400) {
          errorMessage =
            error.response.data.message ||
            "Invalid data provided. Please check your input.";
        } else if (error.response.status === 401) {
          errorMessage = "Unauthorized. Please log in and try again.";
        } else if (error.response.status === 404) {
          errorMessage = "Employee not found. Please verify the Draft ID.";
        } else if (error.response.status >= 500) {
          errorMessage =
            "Server error. Please try again later or contact support.";
        }
      } else if (error.request) {
        errorMessage =
          "No response from server. Please check your network connection.";
      }
      alert(errorMessage);
      setErrors((prev) => ({ ...prev, general: errorMessage }));
    }
  };



  //  useEffect(() => {
  //   const fetchApplicationDetails = async () => {
  //     if (!employeeUniqueId) return;

  //     try {
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_API_BASE_URL}/api/personal-info/${employeeUniqueId}`
  //       );
  //       const appData = response.data;

  //       localStorage.setItem("applicationData", JSON.stringify(appData));
  //       localStorage.setItem("applicationNumber", appData.employeeUniqueId);
  //       localStorage.setItem("applicationPrimaryKey", appData.id);

  //       if (appData.addresses?.length > 0) {
  //         const addr = appData.addresses[0]; // ✅ first address object

  //         setAddressData({
  //           id: addr.id || "",
  //           // ✅ Present address
  //           presentCountry: addr.presentCountry?.id || "",
  //           presentState: addr.presentState?.id || "",
  //           presentDistrict: addr.presentDistrict?.districtId || "",
  //           presentBlock: addr.presentBlock || "",
  //           presentAddressLine1: addr.presentAddressLine1 || "",
  //           presentAddressLine2: addr.presentAddressLine2 || "",
  //           presentPostCode: addr.presentPostCode || "",
  //           // ✅ Permanent address
  //           permanentCountry: addr.permanentCountry?.id || "",
  //           permanentState: addr.permanentState?.id || "",
  //           permanentDistrict: addr.permanentDistrict?.districtId || "",
  //           permanentBlock: addr.permanentBlock || "",
  //           permanentAddressLine1: addr.permanentAddressLine1 || "",
  //           permanentAddressLine2: addr.permanentAddressLine2 || "",
  //           permanentPostCode: addr.permanentPostCode || "",
  //         });

  //         setIsSameAddress(addr.sameAsPresent || false);
  //       }

  //         // ✅ Save name + job position separately
  //       setPersonalInfo({
  //         givenName: appData.givenName || appData.employee?.firstName || "",
  //         surname: appData.surname || appData.employee?.lastName || "",
  //         jobPosition: appData.employee?.jobPosition || "",
  //       });
  //        console.log("Fetched application data:", appData);
  //       console.log("Saved applicationPrimaryKey:", appData.id);
  //       console.log("Saved applicationNumber:", appData.employeeUniqueId);
  //     } catch (error) {
  //       console.error("Error fetching application data:", error);
  //     }
  //   };

  //   fetchApplicationDetails();
  // }, [employeeUniqueId]);
  // useEffect(() => {
  //   console.log("Updated addressData:", addressData);
  // }, [addressData]);


  /*
        const data = await getAddressDetailsBasedonEmployeeUniqueeId(employeeUniqueId);
    this the fetching data  while comming back  from this method 
  */
  useEffect(() => {
    const fetchAddressData = async () => {
      if (!employeeUniqueId) return;

      try {
        setIsLoadingOptions(true);
        // fetch personal info first
        // const personalRes = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/personal-info/${employeeUniqueId}`);
        const appData = await getEmployeeDetailsBasedonEmployeeUniqueeId(employeeUniqueId);
        // const appData = personalRes.data;

        setPersonalInfo({
          givenName: appData.givenName || appData.employee?.firstName || "",
          surname: appData.surname || appData.employee?.lastName || "",
          jobPosition: appData.employee?.jobPosition || "",
        });
        // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/address/${employeeUniqueId}`);
        const data = await getAddressDetailsBasedonEmployeeUniqueeId(employeeUniqueId);
        // const data = response.data;
        const initialPresentBlock = Number(data.presentState?.id) === 3
          ? (data.presentBlock?.id ? String(data.presentBlock.id) : '') // Block ID for Select
          : (data.presentMandal || ''); // Mandal text for Input

        const initialPermanentBlock = data.sameAsPresent
          ? initialPresentBlock // Copy visual state if same
          : (Number(data.permanentState?.id) === 3
            ? (data.permanentBlock?.id ? String(data.permanentBlock.id) : '')
            : (data.permanentMandal || ''));
        setCompleted(appData.completed === true);     // From personal info
        setCompleted(data.completed === true);        // From address data
        setAddressData({
          id: data.id ? String(data.id) : '',
          presentCountry: data.presentCountry?.id ? String(data.presentCountry.id) : '',
          presentState: data.presentState?.id ? String(data.presentState.id) : '',
          presentDistrict: data.presentDistrict?.districtId ? String(data.presentDistrict.districtId) : '',
          presentBlockId: data.presentBlock?.id ? String(data.presentBlock.id) : '',
          presentMandal: data.presentMandal || '',
          presentAddressLine1: data.presentAddressLine1 || '',
          presentAddressLine2: data.presentAddressLine2 || '',
          presentPostCode: data.presentPostCode || '',
          permanentCountry: data.sameAsPresent
            ? data.presentCountry?.id
              ? String(data.presentCountry.id)
              : ''
            : data.permanentCountry?.id
              ? String(data.permanentCountry.id)
              : '',
          permanentCountry: data.permanentCountry?.id ? String(data.permanentCountry.id) : '',
          permanentState: data.permanentState?.id ? String(data.permanentState.id) : '',
          permanentDistrict: data.permanentDistrict?.districtId ? String(data.permanentDistrict.districtId) : '',

          // Store the submission IDs and text
          permanentBlockId: data.permanentBlock?.id ? String(data.permanentBlock.id) : '',
          permanentMandal: data.permanentMandal || '',
          permanentAddressLine1: data.sameAsPresent
            ? data.presentAddressLine1 || ''
            : data.permanentAddressLine1 || '',
          permanentAddressLine2: data.sameAsPresent
            ? data.presentAddressLine2 || ''
            : data.permanentAddressLine2 || '',
          permanentPostCode: data.sameAsPresent
            ? data.presentPostCode || ''
            : data.permanentPostCode || '',
          presentBlock: Number(data.presentState?.id) === 3
            ? data.presentBlockId ? String(data.presentBlockId) : ''
            : data.presentMandal || '',

          permanentBlock: data.sameAsPresent
            ? (Number(data.presentState?.id) === 3 ? (data.presentBlockId ? String(data.presentBlockId) : '') : (data.presentMandal || ''))
            : (Number(data.permanentState?.id) === 3 ? (data.permanentBlockId ? String(data.permanentBlockId) : '') : (data.permanentMandal || '')),
        });

        setIsSameAddress(data.sameAsPresent || false);
        setCompleted(data.completed === true);   // <-- NEW
        setCompleted(appData.completed === true);
        // ✅ Always fetch present address dependencies
        // After setting addressData...
        let presentStateOptions = [];
        let presentDistrictOptions = [];
        let presentBlockOptions = [];
        // Fetch present dependencies
       if (data.presentCountry?.id) {
    const states = await getStatesByCountry(data.presentCountry.id);
    presentStateOptions = states.map(item => ({
        value: item.id,
        label: capitalizeFirstLetter(item.stateName),
    }));
    setStateOptions(presentStateOptions);

    if (data.presentState?.id) {
        const districts = await getDistrict(data.presentState.id);
        presentDistrictOptions = districts.filter(item => ![39, 40, 41].includes(item.districtId))
                                        .map(item => ({ value: item.districtId, label: item.districtName }));
        setPresentDistrictOptions(presentDistrictOptions);

        if (Number(data.presentState?.id) === 3 && data.presentDistrict?.districtId) {
            const blocks = await getBlocks(data.presentDistrict.districtId);
            presentBlockOptions = blocks.map(item => ({
                value: item.id,
                label: capitalizeFirstLetter(item.blockName),
            }));
            setPresentBlockOptions(presentBlockOptions);
        }
    }
}


// 2. Handle sameAsPresent / Copying Options
if (data.sameAsPresent) {
    // ✅ CRITICAL: Copy the **ALREADY FETCHED** options now.
    setPermanentStateOptions(presentStateOptions);
    setPermanentDistrictOptions(presentDistrictOptions);
    setPermanentBlockOptions(presentBlockOptions);

} else {
    // 3. Fetch Permanent dependencies (if not same)
    if (data.permanentCountry?.id) {
        // We need to re-fetch the options here for the permanent fields to load correctly
        const permStates = await getStatesByCountry(data.permanentCountry.id);
        const permanentStateOptions = permStates.map(item => ({
            value: item.id,
            label: capitalizeFirstLetter(item.stateName),
        }));
        setPermanentStateOptions(permanentStateOptions);

        if (data.permanentState?.id) {
            const permDistricts = await getDistrict(data.permanentState.id);
            const permanentDistrictOptions = permDistricts.filter(item => ![39, 40, 41].includes(item.districtId))
                                                    .map(item => ({ value: item.districtId, label: item.districtName }));
            setPermanentDistrictOptions(permanentDistrictOptions);

            if (Number(data.permanentState?.id) === 3 && data.permanentDistrict?.districtId) {
                const permBlocks = await getBlocks(data.permanentDistrict.districtId);
                setPermanentBlockOptions(permBlocks.map(item => ({
                    value: item.id,
                    label: capitalizeFirstLetter(item.blockName),
                })));
            }
        }
    }
}

      }
      catch (error) {
        console.error('Error fetching address data:', error);
        if (error.response?.status !== 404) {
          setErrors((prev) => ({ ...prev, general: 'Failed to load address data' }));
        }

        // fallback: check localStorage
        const savedResponse = localStorage.getItem('savedAddressResponse');
        if (savedResponse) {
          const data = JSON.parse(savedResponse);
          setAddressData((prev) => ({
            ...prev,
            id: data.id ? String(data.id) : prev.id,
            presentCountry: data.presentCountry?.id ? String(data.presentCountry.id) : prev.presentCountry,
            presentState: data.presentState?.id ? String(data.presentState.id) : prev.presentState,
            presentDistrict: data.presentDistrict?.districtId ? String(data.presentDistrict.districtId) : prev.presentDistrict,
            presentBlock: data.presentBlock || prev.presentBlock,
            presentAddressLine1: data.presentAddressLine1 || prev.presentAddressLine1,
            presentAddressLine2: data.presentAddressLine2 || prev.presentAddressLine2,
            presentPostCode: data.presentPostCode || prev.presentPostCode,
            permanentCountry: data.sameAsPresent
              ? data.presentCountry?.id
                ? String(data.presentCountry.id)
                : prev.permanentCountry
              : data.permanentCountry?.id
                ? String(data.permanentCountry.id)
                : prev.permanentCountry,
            permanentState: data.sameAsPresent
              ? data.presentState?.id
                ? String(data.presentState.id)
                : prev.permanentState
              : data.permanentState?.id
                ? String(data.permanentState.id)
                : prev.permanentState,
            permanentDistrict: data.sameAsPresent
              ? data.presentDistrict?.districtId
                ? String(data.presentDistrict.districtId)
                : prev.permanentDistrict
              : data.permanentDistrict?.districtId
                ? String(data.permanentDistrict.districtId)
                : prev.permanentDistrict,
            permanentBlock: data.sameAsPresent
              ? data.presentBlock || prev.permanentBlock
              : data.permanentBlock || prev.permanentBlock,
            permanentAddressLine1: data.sameAsPresent
              ? data.presentAddressLine1 || prev.permanentAddressLine1
              : data.permanentAddressLine1 || prev.permanentAddressLine1,
            permanentAddressLine2: data.sameAsPresent
              ? data.presentAddressLine2 || prev.permanentAddressLine2
              : data.permanentAddressLine2 || prev.permanentAddressLine2,
            permanentPostCode: data.sameAsPresent
              ? data.presentPostCode || prev.permanentPostCode
              : data.permanentPostCode || prev.permanentPostCode,
          }));
          setIsSameAddress(data.sameAsPresent || false);
          setCompleted(data.completed === true);   // <-- NEW
          // setCompleted(appData.completed === true);
        }

      } finally {
        setIsLoadingOptions(false);
      }
    };
    if (!effectRan.current) {
      fetchAddressData();
    }
    return () => {
      effectRan.current = true;
    }

  }, [employeeUniqueId]);

  // Define method outside JSX
  const handlePreviousClick = () => {
    const isFormEmpty =
      !addressData.presentAddressLine1 &&
      !addressData.presentAddressLine2 &&
      !addressData.presentCountry &&
      !addressData.presentState &&
      !addressData.presentDistrict &&
      !addressData.presentBlock &&
      !addressData.presentPostCode &&
      !addressData.permanentAddressLine1 &&
      !addressData.permanentAddressLine2 &&
      !addressData.permanentCountry &&
      !addressData.permanentState &&
      !addressData.permanentDistrict &&
      !addressData.permanentBlock &&
      !addressData.permanentPostCode;

    if (isFormEmpty || !isDirty) {
      onPrevious(); // Directly go back if empty
    } else {
      setShowConfirmModal(true); // Show modal if form has data
    }
  };

  // Define method outside JSX
  const handleConfirmYes = () => {
    setAddressData({
      presentAddressLine1: "",
      presentAddressLine2: "",
      presentCountry: "",
      presentState: "",
      presentDistrict: "",
      presentBlock: "",
      presentPostCode: "",
      permanentCountry: "",
      permanentState: "",
      permanentDistrict: "",
      permanentBlock: "",
      permanentAddressLine1: "",
      permanentAddressLine2: "",
      permanentPostCode: "",
    });
    setAddressData(emptyAddressData);
    setShowConfirmModal(false);
    onPrevious(); // Navigate back
  };
  const emptyAddressData = {
    presentAddressLine1: "",
    presentAddressLine2: "",
    presentCountry: "",
    presentState: "",
    presentDistrict: "",
    presentBlock: "",
    presentPostCode: "",
    permanentCountry: "",
    permanentState: "",
    permanentDistrict: "",
    permanentBlock: "",
    permanentAddressLine1: "",
    permanentAddressLine2: "",
    permanentPostCode: "",
  };
  // put this inside your component, above return()





  const handleConfirmNo = () => {
    setShowConfirmModal(false);
  };
  const getStateId = (type) => {
    if (type === 'present') {
      return addressData.presentState;
    } else if (type === 'permanent') {
      return addressData.permanentState;
    }
    return '';
  };
  const getBlockMandalValue = (type) => {
  const stateId = type === 'present' ? addressData.presentState : addressData.permanentState;
  const blockId = type === 'present' ? addressData.presentBlockId : addressData.permanentBlockId;
  const mandal = type === 'present' ? addressData.presentMandal : addressData.permanentMandal;

  return Number(stateId) === 3 ? blockId : mandal;
};

const getBlockMandalFocused = (type) => {
  return type === 'present' ? isBlockFocused : isPermBlockFocused;
};
  return (
    <React.Fragment>
      <div className="main-container">
        <div className="Addressdetails-heading"><span className="highlight-label">Temporary ID : </span>
          {employeeUniqueId} - {personalInfo.givenName} {personalInfo.surname} - {personalInfo.jobPosition.designationName}
        </div>

        <div className="container">
          {errors.general && <p className="error-message">{errors.general}</p>}
          {isLoadingOptions && <p>Loading address options...</p>}

          <div className="form-container">

            <form onSubmit={handleSubmit}>

              <h2 className="presentaddressdetails-heading">Present Address Details</h2>
              <div className={`addressdetails-floating-label-container ${(addressData.presentAddressLine1 || focusInput.presentAddressLine1) ? 'float-label' : ''}`}>
                <label><span className="required">*</span>Address Line 1</label>
                <input
                  type="text"
                  name="presentAddressLine1"
                  value={addressData.presentAddressLine1}
                  onChange={handleChange}
                  placeholder=""
                  onFocus={() => setFocusInput(prev => ({ ...prev, presentAddressLine1: true }))}
                  onBlur={() => setFocusInput(prev => ({ ...prev, presentAddressLine1: false }))}
                  disabled={isLocked}
                />
                {errors.presentAddressLine1 && <span className="error-message">{errors.presentAddressLine1}</span>}
              </div>

              <div className={`addressdetails-floating-label-container ${(addressData.presentAddressLine2 || focusInput.presentAddressLine2) ? 'float-label' : ''}`}>
                <label>Address Line 2</label>
                <input
                  type="text"
                  name="presentAddressLine2"
                  value={addressData.presentAddressLine2}
                  onChange={handleChange}
                  placeholder=""
                  onFocus={() => setFocusInput(prev => ({ ...prev, presentAddressLine2: true }))}
                  onBlur={() => setFocusInput(prev => ({ ...prev, presentAddressLine2: false }))}
                  disabled={isLocked}
                />
              </div>

              <div className={`addressdetails-floating-label-container ${(addressData.presentCountry || focusInput.presentCountry) ? 'float-label' : ''}`}>
                <label><span className="required">*</span> Country</label>
                <Select
                  name="presentCountry"
                  options={countries}
                  value={countries.find((c) => c.value === Number(addressData.presentCountry)) || null}
                  onChange={(selected) => handleCountryChange(selected, 'presentCountry')}
                  placeholder=""
                  onFocus={() => setFocusInput(prev => ({ ...prev, presentCountry: true }))}
                  onBlur={() => setFocusInput(prev => ({ ...prev, presentCountry: false }))}
                  menuPortalTarget={document.body}
                  // styles={{
                  //   menuPortal: base => ({ ...base, zIndex: 9999 }),
                  //   control: provided => ({
                  //     ...provided,
                  //     backgroundColor: '#fff',
                  //     borderColor: '#c9c9c9',
                  //     boxShadow: 'none',
                  //   }),
                  //   singleValue: provided => ({ ...provided, color: '#000000' }),
                  // }}
                  // styles={selectStyles}
                  isDisabled={isLocked}
                  styles={isLocked ? selectStyleDisable : selectStyles}
                />
                {errors.presentCountry && <span className="error-message">{errors.presentCountry}</span>}
              </div>

              <div className={`addressdetails-floating-label-container ${(addressData.presentState || isStateFocused) ? 'float-label' : ''}`}>
                <label><span className="required">*</span> State</label>
                <Select
                  name="presentState"
                  options={stateOptions}
                  value={stateOptions.find((opt) => opt.value === Number(addressData.presentState)) || null}
                  onChange={(selected) => handleStateChange(selected, 'presentState')}
                  onFocus={() => setIsStateFocused(true)}
                  onBlur={() => setIsStateFocused(false)}
                  placeholder=""
                  isClearable
                  // isDisabled={isLoadingOptions}
                  menuPortalTarget={document.body}
                  // styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                  //  styles={selectStyles}
                  isDisabled={isLocked}
                  styles={isLocked ? selectStyleDisable : selectStyles}
                />
                {errors.presentState && <span className="error-message">{errors.presentState}</span>}
              </div>

              <div className={`addressdetails-floating-label-container ${(addressData.presentDistrict || isDistrictFocused) ? 'float-label' : ''}`}>
                <label><span className="required">*</span> District</label>
                <Select
                  name="presentDistrict"
                  options={presentDistrictOptions}
                  value={presentDistrictOptions.find((opt) => opt.value === Number(addressData.presentDistrict)) || null}
                  onChange={(selected) => handleDistrictChange(selected, 'presentDistrict')}
                  placeholder=""
                  isClearable
                  // isDisabled={isLoadingOptions}
                  onFocus={() => setIsDistrictFocused(true)}
                  onBlur={() => setIsDistrictFocused(false)}
                  menuPortalTarget={document.body}
                  // styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                  // styles={selectStyles}
                  isDisabled={isLocked}
                  styles={isLocked ? selectStyleDisable : selectStyles}
                />
                {errors.presentDistrict && <span className="error-message">{errors.presentDistrict}</span>}
              </div>
              {/* ==== PRESENT BLOCK ==== */}

              <div className={`addressdetails-floating-label-container ${
  (getBlockMandalValue('present') || getBlockMandalFocused('present')) ? 'float-label' : ''
}`}>
                <label>Block / Mandal</label>

                {Number(getStateId('present')) === 3 ? (
                  /* ----- TEXT INPUT for Bihar ----- */
                  <Select
                    name="presentBlock"
                    options={presentBlockOptions}
                    value={presentBlockOptions.find(o => String(o.value) === addressData.presentBlockId) || null}
                    onChange={(sel) => handleBlockSelectChange(sel, 'present')} // Use new dedicated handler
                    placeholder=""
                    isClearable
                    isDisabled={isLocked}
                    styles={isLocked ? selectStyleDisable : selectStyles}
                    onFocus={() => setIsBlockFocused(true)}
                    onBlur={() => setIsBlockFocused(false)}
                  />

                ) : (
                  /* ----- SELECT for all other states ----- */
                  <input
                    type="text"
                    name="presentBlock"
                    value={addressData.presentMandal}
                    onChange={handleChange}
                    placeholder="Enter Mandal"
                    onFocus={() => setIsBlockFocused(true)}
                    onBlur={() => setIsBlockFocused(false)}
                    disabled={isLocked}
                  />
                )}

                {errors.presentBlock && <span className="error-message">{errors.presentBlock}</span>}
              </div>
              {/* <div className={`addressdetails-floating-label-container ${(addressData.presentBlock || isBlockFocused) ? 'float-label' : ''}`}>
                <label>Block / Mandal</label>
                <input
                  type="text"
                  name="presentBlock"
                  value={addressData.presentBlock}
                  onChange={handleChange}
                  placeholder=""
                  onFocus={() => setIsBlockFocused(true)}
                  onBlur={() => setIsBlockFocused(false)}
                  disabled={isLocked}
                /> 
                <div className={`addressdetails-floating-label-container ${(addressData.presentBlock || isBlockFocused) ? 'float-label' : ''}`}>
                  <label>Block / Mandal</label>

                  <Select
                    name="presentBlock"
                    options={presentBlockOptions}
                    value={presentBlockOptions.find(o => o.value === Number(addressData.presentBlock)) || null}
                    onChange={(sel) => {
                      setAddressData(prev => ({ ...prev, presentBlock: sel ? String(sel.value) : '' }));
                      if (isSameAddress) {
                        setAddressData(prev => ({ ...prev, permanentBlock: sel ? String(sel.value) : '' }));
                      }
                    }}
                    placeholder=""
                    isClearable
                    isDisabled={isLocked}
                    styles={isLocked ? selectStyleDisable : selectStyles}
                    onFocus={() => setIsBlockFocused(true)}
                    onBlur={() => setIsBlockFocused(false)}
                  />

                  {errors.presentBlock && <span className="error-message">{errors.presentBlock}</span>}
                </div>
                {errors.presentBlock && <span className="error-message">{errors.presentBlock}</span>}
              </div> */}

              <div className={`addressdetails-floating-label-container ${(addressData.presentPostCode || focusInput.presentPostCode) ? 'float-label' : ''}`}>
                <label><span className="required">*</span> Postcode</label>
                <input
                  type="text"
                  name="presentPostCode"
                  value={addressData.presentPostCode}
                  onChange={handleChange}
                  maxLength="6"
                  pattern="^[0-9]{6}$"
                  placeholder=""
                  onFocus={() => setFocusInput(prev => ({ ...prev, presentPostCode: true }))}
                  onBlur={() => setFocusInput(prev => ({ ...prev, presentPostCode: false }))}
                  disabled={isLocked}
                />
                {errors.presentPostCode && <span className="error-message">{errors.presentPostCode}</span>}
              </div>
            </form>
          </div>

          <div className="form-container">
            <form>
              <h2 className="premanentaddressdetails-heading">Permanent Address Details</h2>
              <div className="same-address-checkbox">
                <label>
                  <input
                    type="checkbox"
                    checked={isSameAddress}
                    onChange={handleSameAddressChange}
                  />
                  Same as Present Address
                </label>
              </div>

              <div className={`premanentaddressdetails-floating-label-container ${(addressData.permanentAddressLine1 || focusPermanentInput.permanentAddressLine1) ? 'float-label' : ''}`}>
                <label><span className="required">*</span>Address Line 1</label>
                <input
                  type="text"
                  name="permanentAddressLine1"
                  value={addressData.permanentAddressLine1}
                  onChange={(e) => !isSameAddress && handleChange(e)}
                  placeholder=""
                  // disabled={isSameAddress||isFieldDisabled}
                  onFocus={() => setFocusPermanentInput(prev => ({ ...prev, permanentAddressLine1: true }))}
                  onBlur={() => setFocusPermanentInput(prev => ({ ...prev, permanentAddressLine1: false }))}
                  disabled={isFieldDisabled || isSameAddress}
                />
                {errors.permanentAddressLine1 && <span className="error-message">{errors.permanentAddressLine1}</span>}
              </div>

              <div className={`premanentaddressdetails-floating-label-container ${(addressData.permanentAddressLine2 || focusPermanentInput.permanentAddressLine2) ? 'float-label' : ''}`}>
                <label>Address Line 2</label>
                <input
                  type="text"
                  name="permanentAddressLine2"
                  value={addressData.permanentAddressLine2}
                  onChange={(e) => !isSameAddress && handleChange(e)}
                  placeholder=""
                  // disabled={isSameAddress}
                  onFocus={() => setFocusPermanentInput(prev => ({ ...prev, permanentAddressLine2: true }))}
                  onBlur={() => setFocusPermanentInput(prev => ({ ...prev, permanentAddressLine2: false }))}
                  disabled={isFieldDisabled || isSameAddress}
                />
              </div>

              <div className={`premanentaddressdetails-floating-label-container ${(addressData.permanentCountry || focusPermanentInput.permanentCountry) ? 'float-label' : ''}`}>
                <label><span className="required">*</span> Country</label>
                <Select
                  name="permanentCountry"
                  options={countries}
                  value={countries.find((opt) => opt.value === Number(addressData.permanentCountry)) || null}
                  onChange={(selected) => !isSameAddress && handleCountryChange(selected, 'permanentCountry')}
                  placeholder=""
                  // isDisabled={isSameAddress}
                  onFocus={() => setFocusPermanentInput(prev => ({ ...prev, permanentCountry: true }))}
                  onBlur={() => setFocusPermanentInput(prev => ({ ...prev, permanentCountry: false }))}
                  menuPortalTarget={document.body}
                  // styles={{
                  //   menuPortal: base => ({ ...base, zIndex: 9999 }),
                  //   control: provided => ({
                  //     ...provided,
                  //     backgroundColor: isSameAddress ? 'transparent' : '#fff',
                  //   }),
                  //   singleValue: provided => ({ ...provided, color: '#000000' }),
                  // }}
                  isDisabled={isFieldDisabled || isSameAddress}
                  styles={isFieldDisabled ? selectStyleDisable : selectStyles}
                />
                {errors.permanentCountry && <span className="error-message">{errors.permanentCountry}</span>}
              </div>

              <div className={`premanentaddressdetails-floating-label-container ${(addressData.permanentState || isPermStateFocused) ? 'float-label' : ''}`}>
                <label><span className="required">*</span> State</label>
                <Select
                  name="permanentState"
                  options={permanentStateOptions}
                  value={permanentStateOptions.find((opt) => opt.value === Number(addressData.permanentState)) || null}
                  onChange={(selected) => !isSameAddress && handleStateChange(selected, 'permanentState')}
                  onFocus={() => setIsPermStateFocused(true)}
                  onBlur={() => setIsPermStateFocused(false)}
                  placeholder=""
                  isClearable
                  // isDisabled={isSameAddress || isLoadingOptions}
                  menuPortalTarget={document.body}
                  // styles={{
                  //   menuPortal: base => ({ ...base, zIndex: 9999 }),
                  //   control: provided => ({
                  //     ...provided,
                  //     backgroundColor: isSameAddress ? 'transparent' : '#fff',
                  //   }),
                  //   singleValue: provided => ({ ...provided, color: '#000000' }),
                  // }}
                  isDisabled={isFieldDisabled || isSameAddress}
                  styles={isFieldDisabled ? selectStyleDisable : selectStyles}
                />
                {errors.permanentState && <span className="error-message">{errors.permanentState}</span>}
              </div>

              <div className={`premanentaddressdetails-floating-label-container ${(addressData.permanentDistrict || isPermDistrictFocused) ? 'float-label' : ''}`}>
                <label><span className="required">*</span> District</label>
                <Select
                  name="permanentDistrict"
                  options={permanentDistrictOptions}
                  value={permanentDistrictOptions.find(opt => opt.value === Number(addressData.permanentDistrict)) || null}
                  onChange={(selected) => !isSameAddress && handleDistrictChange(selected, 'permanentDistrict')}
                  onFocus={() => setIsPermDistrictFocused(true)}
                  onBlur={() => setIsPermDistrictFocused(false)}
                  placeholder=""
                  isClearable
                  //isDisabled={isSameAddress || isLoadingOptions}
                  menuPortalTarget={document.body}
                  // styles={{
                  //   menuPortal: base => ({ ...base, zIndex: 9999 }),
                  //   control: provided => ({
                  //     ...provided,
                  //     backgroundColor: isSameAddress ? 'transparent' : '#fff',
                  //   }),
                  //   singleValue: provided => ({ ...provided, color: '#000000' }),
                  // }}
                  isDisabled={isFieldDisabled || isSameAddress}
                  styles={isFieldDisabled ? selectStyleDisable : selectStyles}
                />
                {errors.permanentDistrict && <span className="error-message">{errors.permanentDistrict}</span>}
              </div>
              {/* ==== PERMANENT BLOCK ==== */}
              <div className={`premanentaddressdetails-floating-label-container ${
  (getBlockMandalValue('permanent') || getBlockMandalFocused('permanent')) ? 'float-label' : ''
}`}>
                <label>Block / Mandal</label>

                {Number(getStateId('permanent')) === 3 ? (
                  /* ----- TEXT INPUT for Bihar ----- */
                  <Select
                    name="permanentBlock"

                    options={permanentBlockOptions}
                    // Use permanentBlockId for value comparison
                    value={permanentBlockOptions.find(o => String(o.value) === addressData.permanentBlockId) || null}
                    // ✅ Use the correct handler
                    onChange={(sel) => !isSameAddress && handleBlockSelectChange(sel, 'permanent')}
                    placeholder=""
                    isClearable
                    isDisabled={isFieldDisabled || isSameAddress}
                    styles={isFieldDisabled ? selectStyleDisable : selectStyles}
                    onFocus={() => setIsPermBlockFocused(true)}
                    onBlur={() => setIsPermBlockFocused(false)}
                  />

                ) : (
                  /* ----- SELECT for all other states ----- */
                  <input
                    type="text"
                    name="permanentBlock"
                    value={addressData.permanentMandal}
                    onChange={(e) => !isSameAddress && handleChange(e)}
                    placeholder="Enter Mandal"
                    onFocus={() => setIsPermBlockFocused(true)}
                    onBlur={() => setIsPermBlockFocused(false)}
                    disabled={isFieldDisabled || isSameAddress}
                  />
                )}

                {errors.permanentBlock && <span className="error-message">{errors.permanentBlock}</span>}
              </div>
              {/* <div className={`premanentaddressdetails-floating-label-container ${(addressData.permanentBlock || isPermBlockFocused) ? 'float-label' : ''}`}>
                <label> Block / Mandal</label>
                <input
                  type="text"
                  name="permanentBlock"
                  value={addressData.permanentBlock}
                  onChange={(e) => !isSameAddress && handleChange(e)}
                  placeholder=""
                  onFocus={() => setIsPermBlockFocused(true)}
                  onBlur={() => setIsPermBlockFocused(false)}
                  disabled={isFieldDisabled || isSameAddress}
                />
                <Select
                  name="permanentBlock"
                  options={permanentBlockOptions}
                  value={permanentBlockOptions.find(o => o.value === Number(addressData.permanentBlock)) || null}
                  onChange={(sel) => !isSameAddress && setAddressData(prev => ({
                    ...prev,
                    permanentBlock: sel ? String(sel.value) : ''
                  }))}
                  placeholder=""
                  isClearable
                  isDisabled={isFieldDisabled || isSameAddress}
                  styles={isFieldDisabled ? selectStyleDisable : selectStyles}
                  onFocus={() => setIsPermBlockFocused(true)}
                  onBlur={() => setIsPermBlockFocused(false)}
                />
                {errors.permanentBlock && <span className="error-message">{errors.permanentBlock}</span>}
              </div> */}

              <div className={`premanentaddressdetails-floating-label-container ${(addressData.permanentPostCode || focusPermanentInput.permanentPostCode) ? 'float-label' : ''}`}>
                <label> <span className="required">*</span>Postcode</label>
                <input
                  type="text"
                  name="permanentPostCode"
                  value={addressData.permanentPostCode}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,6}$/.test(value) && !isSameAddress) {
                      handleChange(e);
                    }
                  }}
                  maxLength="6"
                  pattern="^[0-9]{6}$"
                  placeholder=""
                  // disabled={}
                  disabled={isFieldDisabled || isSameAddress}
                  onFocus={() => setFocusPermanentInput(prev => ({ ...prev, permanentPostCode: true }))}
                  onBlur={() => setFocusPermanentInput(prev => ({ ...prev, permanentPostCode: false }))}
                />
                {errors.permanentPostCode && <span className="error-message">{errors.permanentPostCode}</span>}
              </div>
            </form>
          </div>
        </div>
        <div className='addressdetails-btns-div'>
          <button
            type="button"
            className="addressdetails-btn"
            onClick={handlePreviousClick}
          >
            Previous
          </button>

          <button type="submit" className="addressdetails-btn-next" onClick={handleSubmit} disabled={!isNextEnabled || isLoadingOptions}>Save & Next</button>
        </div>

        {/* {showConfirmModal && (
          <div className="modal-overlay">
            <div className="custom-modal">
              <p>Do you want to clear the form?</p>
              <div className="modal-buttons">
                <button type="button" onClick={handleConfirmYes}>
                  Yes
                </button>
                <button type="button" onClick={handleConfirmNo}>
                  No
                </button>

              </div>
            </div>
          </div>
        )} */}
        {showConfirmModal && (
          <ConfirmModal
            message="Do you want to clear the form?"
            onConfirm={handleConfirmYes}
            onCancel={handleConfirmNo}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default AddressDetails;